import { Injectable } from '@angular/core';
import { Events, LoadingController, ToastController } from 'ionic-angular';

@Injectable()
export class ErrorHandling {

    loader = this.loadingCtrl.create({});

    constructor(public toastCtrl: ToastController,
                public loadingCtrl: LoadingController,
                public events: Events) {
    }

    /**
     * Handles the error case.
     * @param error
     * @param {string} origin
     */
    handle(error: any, origin?: string) {
        let duration: number = 2500;
        let msg: string;
        //TODO What should happen, when an unknown error occurs?
        if (!error) {
            console.error('Unknown Error occured');
            let toast = this.toastCtrl.create({
                message: 'Bitte melden Sie sich an.',
                duration: duration,
                position: 'top'
            });
            toast.present();
            this.events.publish('Error(403)');
        } else {
            // Outdated/Invalid security information
            if (error.status == 403) {

                if (error._body == 'Fehler bei der Anmeldung: Benutzername oder Passwort falsch.') {
                    msg = 'Fehler bei der Anmeldung: Benutzername oder Passwort falsch. (403)';
                }
                else if (error._body == 'Invalid security information!' && error.statusText == 'OK') {
                    msg = 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an. (403)';
                }
                else if (error._body == 'Invalid security information!' && error.statusText == 'Access Forbidden') {
                    msg = 'Sie wurden abgemeldet. (403)';
                } else {
                    msg = 'Sitzung abgelaufen bzw. ungültig (403)';
                }

                let toast = this.toastCtrl.create({
                    message: msg,
                    duration: duration,
                    position: 'top'
                });
                toast.present();

                this.events.publish('Error(403)');
            }

            // Bad Request
            else if (error.status == 400) {

                if (error._body == 'User has no access to the given organization structure!') {
                    msg = 'Sie haben keinen Zugriff auf die angeforderte Struktur! (400)';
                } else if (error._body == 'Es wurden keine Suchkriterien angegeben.') {
                    msg = 'Es wurden keine Suchkriterien angegeben. (400)';
                } else if (error._body == 'Es wurden zu viele Schriftstücke gefunden.') {
                    msg = 'Es wurden zu viele Schriftstücke gefunden (400).';
                } else if (error._body == 'Es wurden zu viele Teilakten/Vorgänge gefunden.') {
                    msg = 'Es wurden zu viele Teilakten/Vorgänge gefunden. (400)';
                } else if (error._body == 'Es wurden zu viele Adressen gefunden.') {
                    msg = 'Es wurden zu viele Adressen gefunden. (400)';
                } else if (error._body == 'Fehler bei der Anmeldung: Es wurde eine leere Anmeldekennung übergeben.') {
                    msg = 'Fehler bei der Anmeldung: Es wurde eine leere Anmeldekennung übergeben. (400)';
                }
                else {
                    msg = 'Bad request (ungültige Anforderung). (400)';
                }

                let toast = this.toastCtrl.create({
                    message: msg,
                    duration: duration,
                    position: 'top'
                });
                toast.present();
            }

            // Server Error
            else if (error.status == 500) {

                let toast = this.toastCtrl.create({
                    message: 'Die Aktion kann derzeit nicht ausgeführt werden. Bitte versuchen Sie es später erneut.' +  ' (' + error.status + ')',
                duration: duration,
                position: 'top'
            });
            toast.present();
        }

        // Service Unavailable
        else if (error.status == 503 && error.statusText == 'Service Unavailable') {

            let toast = this.toastCtrl.create({
                message: 'Die Aktion kann derzeit nicht ausgeführt werden. Bitte versuchen Sie es später erneut.' +  ' (' + error.status + ')',
                    duration: duration,
                    position: 'top'
                });
                toast.present();
            }

            // Not enough user licenses
            else if (error.status == 401) {

                let toast = this.toastCtrl.create({
                    message: 'Nicht authorisierter Zugriff. ' + error._body,
                    duration: duration,
                    position: 'top'
                });
                toast.present();
            }

            // Timeout
            else if (error.name == 'TimeoutError' || error.message == 'Timeout has occurred') {

                let toast = this.toastCtrl.create({
                    message: 'Zeitüberschreitung bei der Anfrage. Bitte prüfen Sie Ihre Internetverbindung',
                    duration: duration,
                    position: 'top'
                });
                toast.present();
            }

            // Lost Connection
            else if (error.status == 0) {
                let toast = this.toastCtrl.create({
                    message: 'Bitte prüfen Sie Ihre Internetverbindung',
                    duration: duration,
                    position: 'top'
                });
                toast.present();
            }

            // Custom - Fehler beim öffnen der Datei.
            else if (error.status == 901) {
                let toast = this.toastCtrl.create({
                    message: error._body + ' (' + error.status + ')',
                    duration: duration,
                    position: 'top'
                });
                toast.present();
            }

            // Custom - Unbekanntes Dateiformat.
            else if (error.status == 902) {
                let toast = this.toastCtrl.create({
                    message: error._body + ' (' + error.status + ')',
                    duration: duration,
                    position: 'top'
                });
                toast.present();
            }

            // Custom - Datei konnte nicht geladen werden.
            else if (error.status == 903) {
                let toast = this.toastCtrl.create({
                    message: error._body + ' (' + error.status + ')',
                    duration: duration,
                    position: 'top'
                });
                toast.present();
            }

            // Custom - Nicht angemeldet (Versuch seite über Menu zu öffnen ohne angemeldet zu sein).
            else if (error.status == 904) {
                let toast = this.toastCtrl.create({
                    message: error._body + ' (' + error.status + ')',
                    duration: duration,
                    position: 'top'
                });
                toast.present();
            }

            // Custom - SPIRIT.NODE nicht erreichbar
            else if(error.status == 905){
                let toast = this.toastCtrl.create({
                    message: error._body + ' (' + error.status + ')',
                    duration: duration,
                    position: 'top'
                });
                toast.present();
            }

            // Custom - SPIRIT.NODE erreichbar aber nicht der IQ-Server (NodeInterfServer)
            else if(error.status == 906){
                let toast = this.toastCtrl.create({
                    message: error._body + ' (' + error.status + ')',
                    duration: duration,
                    position: 'top'
                });
                toast.present();
            }

            // Custom - ObjectDatasets: null
            else if(error.status == 907){
                let toast = this.toastCtrl.create({
                    message: error._body + ' (' + error.status + ')',
                    duration: duration,
                    position: 'top'
                });
                toast.present();
            }

            // Custom - SecureStorage Fehler
            else if(error.status == 908){
                let toast = this.toastCtrl.create({
                    message: error._body + ' (' + error.status + ')',
                    duration: duration,
                    position: 'top'
                });
                toast.present();
            }

            // Zertifikats-/Verbindungsfehler
            else if(error.status == 909){
                let toast = this.toastCtrl.create({
                    message: error._body + ' (' + error.status + ')',
                    duration: duration,
                    position: 'top'
                });
                toast.present();
            }

            // something else
            else {

                console.log('Unbekannter Fehler -> error.handling.ts: ',  error);

                // let toast = this.toastCtrl.create({
                // message: 'Unbekannter Fehler.' +  ' (' + error._body + ')',
                // duration: duration,
                // position: 'top'
                // });
                //toast.present();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/shared/error.handling.ts